import { FormattedDate, FormattedMessage } from 'react-intl'

interface PeriodTextProps {
  startDate: string
  endDate?: string | null
}

export function PeriodText({ startDate, endDate }: PeriodTextProps) {
  if (!endDate) {
    return (
      <FormattedMessage
        id="period.fromDateOnly"
        defaultMessage="{fromDate}-től"
        values={{ fromDate: <FormattedDate value={startDate} /> }}
      />
    )
  }

  return (
    <FormattedMessage
      id="period.fromToDate"
      defaultMessage="{fromDate} - {toDate}"
      values={{
        fromDate: <FormattedDate value={startDate} />,
        toDate: <FormattedDate value={endDate} />,
      }}
    />
  )
}
